import { Outlet, useNavigate, useLocation, NavLink } from "react-router";
import { useAppSelector, useAppDispatch } from "../store/hooks";
import { useEffect, useState } from "react";
import { logout } from "../features/auth/authSlice";
import { toast } from "react-toastify";

import {
  Bars3Icon,
  CalendarIcon,
  ChartPieIcon,
  DocumentDuplicateIcon,
  FolderIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon,
  ArrowsPointingOutIcon
} from "@heroicons/react/24/outline";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
export default function AdminLayout() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [role, setRole] = useState<string>("");
  const [navItems, setNavItems] = useState([]);

  const { user, defaultRole } = useAppSelector((s) => s.auth);

  const userRoles = user?.roles || [];

  // let navItems = [];
  console.log("User Roles in DashBoardLayout.tsx:", userRoles);
  const renderbasedOnRole = () => {
    if (defaultRole === "admin") {
      setRole("admin");
      setNavItems([
        { name: "Admin Dashboard", path: "/dashboard", icon: HomeIcon },
        { name: "User Lists", path: "/user-list", icon: UsersIcon },
        { name: "Appointments", path: "/appointment-list", icon: UsersIcon },
        { name: "Doctor Slots", path: "/doctor-slot-list", icon: UsersIcon },
      ]);
    } else if (defaultRole === "doctor") {
      setRole("doctor");
      setNavItems([
        { name: "Doctor Dashboard", path: "/dashboard", icon: HomeIcon },
        { name: "Update Profile", path: "/update-profile", icon: UsersIcon },
        { name: "Check Appointments", path: "/appointments", icon: CalendarIcon },
        { name: "Search Patients", path: "/patients", icon: FolderIcon },
      ]);
    } else if (defaultRole === "patient") {
      setRole("patient");
      setNavItems([
        { name: "Book Appointment", path: "/dashboard", icon: HomeIcon },
        { name: "Update Profile", path: "/update-profile", icon: UsersIcon },
        // { name: "Book Appointment", path: "/doctors-list", icon: CalendarIcon },
        { name: "Appointments", path: "/appointments", icon: FolderIcon },
        { name: "Reports", path: `/reports`, icon: DocumentDuplicateIcon },
      ]);
    }
    return null;
  };

  useEffect(() => {
    renderbasedOnRole();
  }, [defaultRole]);

  function capitalizeFirstLetter(string) {
    if (string.length === 0) {
      return string; // Handle empty strings
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  if (role === "") {
    return <div>Loading...</div>;
  }

  const handleLogout = () => {
    dispatch(logout());
    toast.info("👋 Successfully logged out!");
    navigate("/");
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <aside className="w-64 bg-indigo-600 text-white flex flex-col">
        <div className="p-6 text-2xl font-bold border-b border-indigo-500">
          {capitalizeFirstLetter(role)} Panel
        </div>
        <nav className="flex-1 p-4 space-y-2">
          <ul role="list" className="-mx-2 space-y-1">
            {navItems.map((item) => (
              <li key={item.name}>
                <NavLink
                  to={item.path}
                  className={classNames(
                    item.current
                      ? "bg-indigo-700 text-white"
                      : "text-indigo-200 hover:bg-indigo-700 hover:text-white",
                    "group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                  )}
                >
                  <item.icon
                    aria-hidden="true"
                    className={classNames(
                      item.current
                        ? "text-white"
                        : "text-indigo-200 group-hover:text-white",
                      "size-6 shrink-0"
                    )}
                  />
                  {item.name}
                </NavLink>
              </li>
            ))}
            <li className="mt-4 pt-4 border-t border-indigo-700">
              <button
                onClick={handleLogout}
                className="
        group flex w-full items-center gap-x-3
        rounded-md p-2 text-sm/6 font-semibold
        text-indigo-200 hover:bg-indigo-700 hover:text-white
      "
              >
                <ArrowsPointingOutIcon
                  aria-hidden="true"
                  className="size-6 shrink-0"
                />
                Logout
              </button>
            </li>
          </ul>
        </nav>
      </aside>

      <main className="flex-1 overflow-y-auto p-8">
        <Outlet />
      </main>
    </div>
  );
}
